import * as React from 'react'

function getSize(el) {
  const bbox = el.getBoundingClientRect()
  return {
    width: bbox.width,
    height: bbox.height
  }
}

function useSize() {
  const ref = React.useRef()
  const [size, setSize] = React.useState()
  const handleResize = React.useCallback(() => {
    if (ref.current) {
      const nextSize = getSize(ref.current)
      setSize(size => ({
        ...nextSize
      }))
    }
  }, [ref])
  React.useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return function() {
      window.removeEventListener('resize', handleResize)
    }
  }, [ref])

  return [ref, size]
}

export default useSize
